export var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';